'use strict';
function shouldProcessEveryNode(node) {
  return true;
}

module.exports = {
  shouldProcessEveryNode: shouldProcessEveryNode,
};



//////////////////
// WEBPACK FOOTER
// /home/circleci/pickle/~/html-to-react/lib/should-process-node-definitions.js
// module id = Z/P9
// module chunks = 0